/**
 * Message text of anything that was thrown (Error, string, Supabase error object, ...).
 * Use in `catch (err: unknown)` blocks instead of `err.message`.
 */
export function getErrorMessage(err: unknown, fallback = 'An unexpected error occurred'): string {
  let message = '';
  if (typeof err === 'string') {
    message = err;
  } else if (err instanceof Error) {
    message = err.message;
  } else if (err && typeof err === 'object' && 'message' in err) {
    message = String((err as { message: unknown }).message);
  }
  return message || fallback;
}

/** The thrown value as an Error (same object when it already is one) */
export function toError(err: unknown): Error {
  return err instanceof Error ? err : new Error(getErrorMessage(err));
}
